import { create, v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/middleware/theme';
import { Keys } from '@holmescorp/common';
import { keymap, pathmap } from '@holmescorp/lcc-state';
import css from '../css/topicgroup.m.css';

export interface NextTopicProperties {
	topicid: string;
	text: string;
}

const factory = create({ theme }).properties<NextTopicProperties>();

export const NextTopic = factory(({ properties, middleware: { theme } }) => {
	const themeCss = theme.classes(css);
	const { topicid, text } = properties();
	const { path } = keymap.get(topicid)!;

	return v(
		'div',
		{
			classes: [themeCss.action],
			role: 'button',
			xqa: 'next-topic-button',
			tabIndex: 0,
			onclick: (event) => {
				event && event.stopPropagation();
				const { view } = pathmap.get(path!)!;
				view();
			},
			onkeydown: (event) => {
				const { view } = pathmap.get(path!)!;
				switch (event.key) {
					case Keys.Enter:
					case Keys.Space:
					case Keys.Spacebar:
						event.preventDefault();
						view();
				}
			}
		},
		[v('div', { classes: [themeCss.actionText] }, [text])]
	);
});

export default NextTopic;
